import { useEffect, useState } from "react";
import BarStackChart from "../../charts/BarStackChart";

const labelFields = [
  'Pasar lokal',
  'Pedagang keliling',
  'Kios',
  'Super market',
  'Mini market',
]
const labelKey = [
  'frekuensi_belanja_pasarlokal',
  'frekuensi_belanja_pedagangkeliling',
  'frekuensi_belanja_kios',
  'frekuensi_makanan_supermarket',
  'frekuensi_makanan_minimarket',
]
export default function KegiatanTransaksiMakanan({ data }) {
  const [graphData, setGraphData] = useState({
    labels: [],
    datasets: []
  })

  useEffect(() => {
    const mapData = {}
    const mapData2 = {}
    const mapData3 = {}
    const mapData4 = {}
    const rawData = {
      labels: [],
      datasets: [
        {
          label: '',
          data: [12, 19, 3, 5, 2, 3],
          backgroundColor: [
            'rgba(4,135,55,1)',
          ],
          borderColor: [
            'rgba(4,135,55,1)',
          ],
          borderWidth: 1,
        },
        {
          label: '',
          data: [12, 19, 3, 5, 2, 3],
          backgroundColor: [
            'rgba(92,114,74,1)',
          ],
          borderColor: [
            'rgba(92,114,74,1)',
          ],
          borderWidth: 1,
        },
        {
          label: '',
          data: [12, 19, 3, 5, 2, 3],
          backgroundColor: [
            'rgba(163,182,138,1)',
          ],
          borderColor: [
            'rgba(163,182,138,1)',
          ],
          borderWidth: 1,
        },
        {
          label: '',
          data: [12, 19, 3, 5, 2, 3],
          backgroundColor: [
            'rgba(199,183,147,1)',
          ],
          borderColor: [
            'rgba(199,183,147,1)',
          ],
          borderWidth: 1,
        },
      ],
    };
    labelFields.map(field => {
      mapData[field] = 0
      mapData2[field] = 0
      mapData3[field] = 0
      mapData4[field] = 0
      return field
    })
    let lengthA = 0;
    let lengthB = 0;
    let lengthC = 0;
    let lengthD= 0;
    let lengthE= 0;
    data.map(item => {
      labelKey.forEach(function (field, i) {
        if([1,2,3,4].indexOf(item[field]) !== -1){
          if(i===0){
            lengthA +=1
          }
          if(i===1){
            lengthB +=1
          }
          if(i===2){
            lengthC +=1
          }
          if(i===3){
            lengthD +=1
          }
          if(i===4){
            lengthE +=1
          }
        }

        if(item[field] === 1){
          mapData[labelFields[i]] += 1
        }
        if(item[field] === 2){
          mapData2[labelFields[i]] += 1
        }
        if(item[field] === 3){
          mapData3[labelFields[i]] += 1
        }
        if(item[field] === 4){
          mapData4[labelFields[i]] += 1
        }
      })
      return item
    })
    rawData.labels = Object.keys(mapData)
    rawData.datasets[0].data = []
    rawData.datasets[1].data = []
    rawData.datasets[2].data = []
    rawData.datasets[3].data = []
    rawData.labels.forEach(function (item, i) {
      let length = 0;
      if(i===0){
        length = lengthA;
      }
      if(i===1){
        length = lengthB;
      }
      if(i===2){
        length = lengthC;
      }
      if(i===3){
        length = lengthD;
      }
      if(i===4){
        length = lengthE;
      }
      rawData.datasets[0].label = 'Sama'
      rawData.datasets[1].label = 'Berkurang'
      rawData.datasets[2].label = 'Bertambah'
      rawData.datasets[3].label = 'Tidak Pernah'
      rawData.datasets[0].data.push(((mapData[item]/length)*100).toFixed(1))
      rawData.datasets[1].data.push(((mapData2[item]/length)*100).toFixed(1))
      rawData.datasets[2].data.push(((mapData3[item]/length)*100).toFixed(1))
      rawData.datasets[3].data.push(((mapData4[item]/length)*100).toFixed(1))
      return item
    })
    
    setGraphData(rawData)
  }, [data]);

  return (
    <BarStackChart
    isXaxis={false}
      height={350}
      data={graphData}
    />
  )
}